<template>
  <div class="page">
    <div class="head-title">
      <div class="left">
        <ul class="breadcrumb">
          <li>
            <a href="#">{{ $t("purchases") }}</a>
          </li>
          <li>-</li>
          <li>
            <a href="#">{{ $t("orders") }} {{ $t("purchase") }}</a>
          </li>
          <li>-</li>
          <li>
            <a class="active" href="#">
              {{ $t("order") }} {{ $t("purchase") }} - ORD-{{ alldata2.oid }}</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="head-option">
      <ul>
        <!-- <li>
                  <a href="#" class="btn-download">
                    <span class="text">Download PDF</span>
                  </a>
                </li> -->
        <li>
          <router-link
            to="/AdminDashboard/AllPurchaseOrder"
            class="btn-download"
          >
            <span class="text">
              <i class="bi bi-arrow-left-square-fill"></i>
              {{ $t("back") }}</span
            >
          </router-link>
        </li>
      </ul>
    </div>
    <div class="main">
      <div class="head">
        <h3>{{ $t("order") }} {{ $t("purchase") }} - ORD-{{ alldata2.oid }}</h3>
      </div>
      <div class="body">
        <div class="part1">
          <div class="part11">
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm"
                >{{ $t("number") }}
              </label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  ORD-{{ alldata2.oid }}
                </div>
              </div>
            </div>
            <div class="row mb-2" v-if="alldata2.qte != null">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm"
                >{{ $t("offer") }} {{ $t("price") }}
              </label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  QTE-{{ alldata2.qte }}
                </div>
              </div>
            </div>
            <!--  -->
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm"
                >{{ $t("date") }}
              </label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.due }}
                </div>
              </div>
            </div>
            <!--  -->
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm"
                >{{ $t("description") }}
              </label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.description }}
                </div>
              </div>
            </div>
            <!--  -->
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm"
                >{{ $t("date") }} {{ $t("due") }}
              </label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.duedate }}
                </div>
              </div>
            </div>
            <!--  -->
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm"
                >{{ $t("date") }} {{ $t("supply") }}
              </label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.supplydate }}
                </div>
              </div>
            </div>
          </div>
          <div class="part12">
            <h4>{{ $t("data") }} {{ $t("supplier") }}</h4>

            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("name") }}
              </label>
              <div class="col-sm-7">
                {{ alldata2.cname }}
              </div>
            </div>
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("mobile") }}
              </label>
              <div class="col-sm-7">
                {{ alldata2.cmobile }}
              </div>
            </div>
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("email") }}
              </label>
              <div class="col-sm-7">
                {{ alldata2.cmail }}
              </div>
            </div>
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("tax") }}
              </label>
              <div class="col-sm-7">
                {{ alldata2.ctax }}
              </div>
            </div>
          </div>
        </div>
        <div class="part2">
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th style="width: 12%">{{ $t("product") }}</th>
                <th>{{ $t("description") }}</th>
                <th style="width: 10%">{{ $t("quantity") }}</th>
                <th style="width: 10%">{{ $t("unit type") }}</th>
                <th>{{ $t("price") }}</th>
                <th>{{ $t("discount") }}</th>
                <th>{{ $t("total") }} {{ $t("befor") }} {{ $t("tax") }}</th>
                <th>{{ $t("tax") }}</th>
                <th>{{ $t("amount") }} {{ $t("tax") }}</th>
                <th>{{ $t("total") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, id) in details" :key="value">
                <td>{{ id + 1 }}</td>
                <td>{{ value.pronamear }}</td>
                <td>
                  {{ value.description }}
                </td>
                <td>
                  {{ value.quantity }}
                </td>
                <td>{{ value.unittype }}</td>
                <td>{{ value.buyp }}</td>
                <td>{{ value.discount }} %</td>
                <td>{{ value.tbt }}</td>
                <td>{{ value.tax }} %</td>
                <td>{{ value.taxamount }}</td>
                <td>{{ value.total }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="6"></td>
                <td>{{ $t("total") }}</td>
                <td>{{ alldata2.tbt }}</td>
                <td></td>
                <td>{{ alldata2.tax }}</td>
                <td>{{ alldata2.tat }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="row mb-2">
          <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
            >{{ $t("branch") }}
          </label>
          <div class="col-sm-2">
            <div class="form-control" id="exampleFormControlTextarea1">
              {{ alldata2.branch }}
            </div>
          </div>
          <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
            >{{ $t("project") }}
          </label>
          <div class="col-sm-2">
            <div class="form-control" id="exampleFormControlTextarea1">
              {{ alldata2.project }}
            </div>
          </div>
          <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
            >{{ $t("task") }}
          </label>
          <div class="col-sm-2">
            <div class="form-control" id="exampleFormControlTextarea1">
              {{ alldata2.task }}
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
            >{{ $t("notes") }}
          </label>
          <div class="col-sm-5">
            <div class="form-control" id="exampleFormControlTextarea1">
              {{ alldata2.notes }}
            </div>
          </div>
        </div>

        <hr />
        <div class="user">
          <i class="bi bi-eye-fill"></i> &nbsp; {{ $t("created") }}
          {{ $t("by") }} : {{ alldata2.username }}
          <div class="udate">
            {{ $t("date") }} : {{ alldata2.date }} - {{ $t("time") }} :
            {{ alldata2.time }}
          </div>
        </div>
        <div class="user" v-if="alldata2.review == 'confirmed'">
          <i class="bi bi-eye-fill"></i> &nbsp; {{ $t("confirmed") }}
          {{ $t("by") }} : {{ alldata2.reviewusername }}
          <div class="udate">
            {{ $t("date") }} : {{ alldata2.reviewdate }} - {{ $t("time") }} :
            {{ alldata2.reviewtime }}
          </div>
        </div>
        <div class="user" v-if="alldata2.review == 'cancel'">
          <i class="bi bi-eye-fill"></i> &nbsp; {{ $t("cancel") }}
          {{ $t("by") }} : {{ alldata2.reviewusername }}
          <div class="udate">
            {{ $t("date") }} : {{ alldata2.reviewdate }} - {{ $t("time") }} :
            {{ alldata2.reviewtime }}
          </div>
        </div>
      </div>
      <br />
      <div class="buttom">
        <button
          class="btn btn-success"
          type="submit"
          @click="confirm"
          v-if="alldata2.review == 'waiting'"
        >
          <i class="bi bi-file-check-fill"></i> {{ $t("confirm") }}
        </button>
        <button class="btn btn-primary" type="submit" @click="print">
          <i class="bi bi-printer-fill"></i> {{ $t("printe") }}
        </button>
        <button class="btn btn-primary" type="submit" @click="pdf">
          <i class="bi bi-filetype-pdf"></i> {{ $t("PDF") }}
        </button>
        <button class="btn btn-dark" type="submit" @click="back">
          {{ $t("cancel") }}
        </button>
      </div>
    </div>
    <div id="main" style="padding: 1%; display: none">
      <div :style="{ direction: css.EN }">
        <img
          :src="this.url"
          crossorigin="anonymous"
          style="height: 200px; width: 50%"
        />
        <div class="part1" style="clear: both">
          <div class="part11" style="display: flex">
            {{ $t("orders") }} {{ $t("purchase") }} {{ $t("number") }} :
            {{ alldata2.oid }}
            &nbsp;&nbsp;&nbsp;&nbsp;
            {{ $t("date") }} :
            {{ alldata2.due }}
            <br />
            {{ $t("description") }} :
            {{ alldata2.description }}
            <br />
          </div>
          <br />
          <div class="part12">
            <h4>{{ $t("data") }} {{ $t("customer") }}</h4>
            <div style="padding: 2%">
              {{ $t("name") }} :
              {{ alldata2.cname }}
              <br />
              {{ $t("mobile") }} :
              {{ alldata2.cmobile }}
              <br />
              {{ $t("email") }} :
              {{ alldata2.cmail }}
              <br />
              {{ $t("tax") }} :
              {{ alldata2.ctax }}
            </div>
          </div>
        </div>
        <br /><br />
        <div class="part2">
          <table style="width: 100%; text-align: center; font-size: small">
            <thead>
              <tr>
                <th>#</th>
                <th style="width: 12%">{{ $t("product") }}</th>
                <th>{{ $t("description") }}</th>
                <th style="width: 10%">{{ $t("quantity") }}</th>
                <th style="width: 10%">{{ $t("unit type") }}</th>
                <th>{{ $t("price") }}</th>
                <th>{{ $t("discount") }}</th>
                <th>{{ $t("total") }} {{ $t("befor") }} {{ $t("tax") }}</th>
                <th>{{ $t("tax") }}</th>
                <th>{{ $t("amount") }} {{ $t("tax") }}</th>
                <th>{{ $t("total") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, id) in details" :key="value">
                <td>{{ id + 1 }}</td>
                <td>{{ value.pronamear }}</td>
                <td>
                  {{ value.description }}
                </td>
                <td>
                  {{ value.quantity }}
                </td>
                <td>{{ value.unittype }}</td>
                <td>{{ value.buyp }}</td>
                <td>{{ value.discount }} %</td>
                <td>{{ value.tbt }}</td>
                <td>{{ value.tax }} %</td>
                <td>{{ value.taxamount }}</td>
                <td>{{ value.total }}</td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td colspan="11"><hr /></td>
              </tr>
              <tr>
                <td colspan="6"></td>
                <td>{{ $t("total") }}</td>
                <td>{{ alldata2.tbt }}</td>
                <td></td>
                <td>{{ alldata2.tax }}</td>
                <td>{{ alldata2.tat }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <hr />

        {{ $t("notes") }} :
        {{ alldata2.notes }}
        <hr />
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
// import useValidate from "@vuelidate/core";
// import { required } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import html2pdf from "html2pdf.js";
export default {
  async mounted() {
    const data2 = await axios.get(
      `/data/purchaseorderview/${this.$route.params.id}`
    );
    if (data2.status == 200) {
      const data = data2.data.data[0];
      this.alldata2 = data;
      this.details = JSON.parse(this.alldata2.details);
      this.totaldpt = this.details.reduce(
        (acc, array) => acc + Number(array.dpt),
        0
      );
      this.totalcrd = this.details.reduce(
        (acc, array) => acc + Number(array.crd),
        0
      );
      this.url =
      store.state.imgurl + `/clogo/${this.$store.state.cnum[0].cnum}.png`;
    }
  },
  props: ["css"],
  data() {
    return {
      alldata2: "",
      details: [],
      fileurl: [],
      url: "",
    };
  },
  methods: {
    confirm() {
      Swal.fire({
        title:
          this.$t("confirm") + " " + this.$t("orders") + " " + this.alldata2.oid,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("confirm"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const action = await axios.post("/data/confirmpurchaseorder", {
            id: this.alldata2.oid,
            username: store.state.randp.username,
          });
          if (action.status == 200) {
            Swal.fire(
              this.$t("done") +
                " " +
                this.$t("confirm") +
                " " +
                this.$t("orders") +
                " " +
                this.alldata2.oid
            );
            this.redirectTo({ val: "AllPurchaseOrder" });
          }
        }
      });
    },
    pdf() {
      html2pdf(document.getElementById("main").innerHTML, {
        margin: 0.2,
        filename: "barcode.pdf",
        image: { type: "jpeg", quality: 100 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      });
    },
    print() {
      this.$htmlToPaper("main");
    },
    print2() {
      this.$htmlToPaper("main");
    },
    ...mapActions(["redirectTo"]),
  },
};
</script>
<style lang="scss" scoped>
.page {
  direction: v-bind("css.EN");
  padding: 1%;
}
a {
  text-decoration: none;
}
.head-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-gap: 16px;
  flex-wrap: wrap;
}
.head-title .left h1 {
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #342e37;
}
.head-title .left .breadcrumb {
  display: flex;
  align-items: center;
  grid-gap: 16px;
}
.head-title .left .breadcrumb li {
  color: #342e37;
}
.head-title .left .breadcrumb li a {
  color: #aaaaaa;
  pointer-events: none;
}
.head-title .left .breadcrumb li a.active {
  color:  v-bind("css.color");
  pointer-events: unset;
}

.head-option {
  direction: v-bind("css.AR");
  width: 100%;
  // border: #342e37 1px solid;
  padding: 0.5%;
}
.head-option ul li {
  display: inline;
  padding: 0.5%;
}
.head-option .btn-download {
  width: 20%;
  padding: 0.5%;
  border-radius: 5px;
  background:  v-bind("css.color");
  color: #f9f9f9;
}
.main .head {
  border-top:  v-bind("css.color") 5px solid;
  background:  v-bind("css.color");
  color: #f9f9f9;
  border-radius: 3px 3px 0px 0px;
  padding: 0.25%;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.main .body {
  background: v-bind("css.light");
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 1%;
  //   display: flex;
}
.main .body .part1 {
  background: v-bind("css.light");
  //   box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 1%;
  display: flex;
  width: 100%;
}
.main .body .part11 {
  width: 50%;
}
.main .body .part12 {
  width: 40%;
  //   border: solid rgba(0, 0, 0, 0.274) 00.5px;
}
.main .body .part2 {
  background: v-bind("css.light");
  padding: 1%;
  width: 100%;
}
.options {
  height: 150px;
  margin: 1%;
  background-color: v-bind("css.light");
  color: v-bind("css.dark");
  padding: 2%;
  overflow-y: auto;
}
.options ul li {
  margin: 0.5%;
}
.options ul li:hover {
  color: white;
  background-color: black;
}
.buttom {
  text-align: center;
}
button {
  margin: 0.5%;
}
.user {
  width: 50%;
  // border: black solid 0.5px;
  padding: 1%;
  border-radius: 5px;
}
.udate {
  font-size: small;
  color: #3c91e6;
}
</style>
